import PathDataTableDetailsResult from "./PathDataTableDetailsResult";
import PathDataTableMappingCapabilitiesDto from "../../../dtos/pathdatatablemodule/PathDataTableMappingCapabilitiesDto";
import TransformationCapabilitiesDto from "../../../dtos/transformationmodule/TransformationCapabilitiesDto";

class GetPathDataTableCapabilitiesResult {
    Fields: PathDataTableDetailsResult[];
    MappingsCapabilities: PathDataTableMappingCapabilitiesDto[];
    TransformationsCapabilities: TransformationCapabilitiesDto[]; 

    constructor(fields: PathDataTableDetailsResult[], mappingsCapabilities: PathDataTableMappingCapabilitiesDto[], transformationCapabilities: TransformationCapabilitiesDto[]) {
        this.Fields = fields;
        this.MappingsCapabilities = mappingsCapabilities;
        this.TransformationsCapabilities = transformationCapabilities;
    }
}

export default GetPathDataTableCapabilitiesResult;
